require('expose-loader?BVLazyLoad!../../src/utils/lazy_load');
